import React, { useState, useEffect } from "react";

import InputRange from "react-input-range";
import { GridContainer, GridItem } from "./../../components/Grid/Grid";
import {
  SimpleInput,
  FormatSimpleInput,
} from "./../../components/Inputs/SimpleInput";
import { CheckerList } from "./../../components/Inputs/FancyCheck";
import { optionalFn } from "../../Core/helpers";
import { Money, FixedNumber } from "../../components/Formats/FormatNumbers";
import "./scss/calculator.scss";
import light from "../../assets/img/light.svg";
import medium from "../../assets/img/medium.svg";
import heavy from "../../assets/img/heavy.svg";
import rule from "../../assets/img/rule.svg";
import user from "../../assets/img/user.svg";
import pig from "../../assets/img/pig.svg";
import { ReactSVG } from "react-svg";
export function ROICalculator({ onChange }) {
  const [vehicles, setVehicles] = useState(0);
  const [kilometers, setKilometers] = useState(0);
  const [gasPrice, setGas] = useState(0);
  const [maintenancePrice, setMaintenance] = useState(750);
  const [salary, setSalary] = useState(18000);
  const [perLiter, setLiters] = useState(8);
  const [carPayment, setPayment] = useState(5000);
  const [spendPerVehicle, setspendPerVehicle] = useState(0);
  const [monthlySavings, setSavings] = useState(0);
  const [unitsSpare, setUnitsSpare] = useState(0);
  const [type, setType] = useState("Delivery truck (712 kg)");
  const [percent, setPercent] = useState(0.23);
  let data = {
    perLiter: perLiter || 1,
    kilometers: kilometers || 1,
    gasPrice,
    maintenancePrice,
    salary,
    carPayment,
    spendPerVehicle,
    monthlySavings,
    unitsSpare,
    vehicles,
    type,
  };
  useEffect(() => {
    optionalFn(onChange)(data);
    setspendPerVehicle(getSpendPerVehicle(data));
  }, [
    vehicles,
    kilometers,
    gasPrice,
    maintenancePrice,
    salary,
    perLiter,
    carPayment,
  ]);
  return (
    <>
      <GridContainer className={"calculator"}>
        <GridItem xs={12} s={6}>
          <h2>
            <span>1</span>Calcula tus ahorros
          </h2>
          Tipo de vehículo
          <CheckerList
            onSelect={({ perLiter, maintenancePrice, carPayment, name }) => {
              setLiters(perLiter);
              setMaintenance(maintenancePrice);
              setPayment(carPayment);
              setType(name);
            }}
            options={[
              {
                icon: light,
                name: "712 kg",
                values: {
                  perLiter: 8,
                  maintenancePrice: 750,
                  carPayment: 5000,
                  name: "Delivery truck 712 kg",
                },
                tooltip: "Camioneta de entrega 712 kg",
              },
              {
                icon: medium,
                name: "3 a 5 Ton",
                values: {
                  perLiter: 4,
                  maintenancePrice: 1000,
                  carPayment: 11700,
                  name: "Camioneta 3 a 5 Ton ",
                },
                tooltip: "Camioneta 3 a 5 Ton ",
              },
              {
                icon: heavy,
                name: "10 Ton",
                values: {
                  perLiter: 3.5,
                  maintenancePrice: 1250,
                  carPayment: 15000,
                  name: "Camioneta 10 Ton",
                },
                tooltip: "Camioneta 10 Ton",
              },
            ]}
          />
          <SimpleInput
            title="Número de vehículos"
            type="number"
            name="vehicles"
            value={vehicles}
            onChange={({ target }) => {
              setVehicles(parseFloat(target.value));
            }}
          />
          <FormatSimpleInput
            title="Distancia recorrida por vehículo (KM) diarios"
            type="number"
            name="kilometes"
            value={kilometers}
            message="En promedio: cada vehiculo, ¿Cuantos kilometros recorre por día?"
            onChange={({ target }) => {
              setKilometers(parseFloat(target.value));
            }}
            format={<strong>{kilometers} km</strong>}
          />
          <FormatSimpleInput
            title="Precio por litro de gasolina"
            type="number"
            name="gasPrice"
            value={gasPrice}
            onChange={({ target }) => {
              setGas(parseFloat(target.value));
            }}
            format={<Money number={gasPrice}></Money>}
          />
          <FormatSimpleInput
            title="Gasto mensual de mantenimiento vehícular"
            type="number"
            name="maintenancePrice"
            message="Aceite,llantas,servicio,reparaciones, etc..."
            value={maintenancePrice}
            onChange={({ target }) => {
              setMaintenance(parseFloat(target.value));
            }}
            format={<Money number={maintenancePrice}></Money>}
          />
          <FormatSimpleInput
            title="Salario mensual del conductor"
            type="number"
            name="salary"
            value={salary}
            message="Incluyendo: Seguro social, sueldo, bonos,prestaciones, prorrateado"
            onChange={({ target }) => {
              setSalary(parseFloat(target.value));
            }}
            format={<Money number={salary}></Money>}
          />
        </GridItem>
        <GridItem
          xs={12}
          s={6}
          className={vehicles && kilometers && gasPrice ? "" : "blocked"}
        >
          <Results
            monthlySavings={monthlySavings}
            unitsSpare={unitsSpare}
            spendPerVehicle={spendPerVehicle}
            vehicles={vehicles}
            onChange={(money, units, savings) => {
              setSavings(money);
              setUnitsSpare(units);
              setPercent(savings);
              optionalFn(onChange)(data);
            }}
          />
        </GridItem>
      </GridContainer>
    </>
  );
}
function Results({
  monthlySavings,
  unitsSpare,
  spendPerVehicle,
  vehicles,
  onChange,
}) {
  return (
    <>
      <h2>
        <span>2</span>Resultados Esperados
      </h2>
      <div className="resultContainer">
        <SavingsRange
          spendPerVehicle={spendPerVehicle}
          vehicles={vehicles}
          title="Escoge tu % de Optimización de rutas"
          onChange={(money, units, savings) => {
            optionalFn(onChange)(money, units, savings);
          }}
        />
        <ResultFormat
          icon={pig}
          title="Ahorros mensuales esperados"
          value={<Money number={monthlySavings}></Money>}
        />
        <ResultFormat
          icon={medium}
          title="Unidades de reparto ahorradas"
          value={<FixedNumber number={unitsSpare} size={1} />}
        />
        <ResultFormat
          icon={user}
          title="Personal ahorrado"
          value={<FixedNumber number={unitsSpare} size={1} />}
        />
      </div>
    </>
  );
}

function SavingsRange({ spendPerVehicle, title, vehicles, onChange }) {
  const [value, setValue] = useState(1);
  let savings = [0.2, 0.25, 0.3, 0.35];
  useEffect(() => {
    optionalFn(onChange)(
      savings[value] * (spendPerVehicle * vehicles),
      savings[value] * vehicles
    );
  }, [spendPerVehicle, vehicles, value]);
  return (
    <div className="savingsRange">
      <label style={{ textAlign: "center" }}>{title}</label>
      <InputRange
        formatLabel={(value) => `${Math.floor(savings[value] * 100)}%`}
        maxValue={3}
        minValue={0}
        value={value}
        onChange={(value) => {
          optionalFn(onChange)(
            savings[value] * (spendPerVehicle * vehicles),
            savings[value] * vehicles,
            savings[value]
          );
          setValue(value);
        }}
      />
      <ReactSVG src={rule} />
    </div>
  );
}

function ResultFormat({ icon, title, value }) {
  return (
    <GridContainer className="results">
      <GridItem s={12} className="icon">
        <ReactSVG src={icon} />
      </GridItem>
      <GridItem s={9} style={{ alingSelf: "center" }} className="values">
        <div className="title">{title}:</div>
        <div className="value">{value}</div>
      </GridItem>
    </GridContainer>
  );
}
function getSpendPerVehicle({
  perLiter,
  kilometers,
  gasPrice,
  maintenancePrice,
  salary,
  carPayment,
}) {
  let liters = kilometers / perLiter;
  let gasSpend = gasPrice * liters * 25;
  let spendPerVehicle = gasSpend + maintenancePrice + carPayment + salary;
  return spendPerVehicle;
}
